import script from "./SubAccordion.vue?vue&type=script&setup=true&lang=js"
export * from "./SubAccordion.vue?vue&type=script&setup=true&lang=js"

import "./SubAccordion.vue?vue&type=style&index=0&id=1b417467&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b417467"]])

export default __exports__